module.exports = __webpack_public_path__ + "static/media/6511.01e6ec56.jpg";